import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from '../types';

const RegularGiveaway: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  ...restProps
}) => {
  const wrapperClassName = css({
    color: color || 'neutrals.text_primary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width || size,
    height: height || size,
  });

  return (
    <span
      data-testid="icon_giveaway"
      className={
        className ? `${wrapperClassName} ${className}` : wrapperClassName
      }
      data-element="icon"
      aria-label="giveaway icon"
      {...restProps}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 25 24"
        width={`${size}px`}
        height={`${size}px`}
        fill="currentcolor"
      >
        <path d="M5.83789 4C4.04297 4 2.58789 5.45507 2.58789 7.25V15.75C2.58789 17.5449 4.04296 19 5.83789 19H19.3379C21.1328 19 22.5879 17.5449 22.5879 15.75V7.25C22.5879 5.45507 21.1328 4 19.3379 4H5.83789ZM4.08789 7.25C4.08789 6.2835 4.87139 5.5 5.83789 5.5H8.58789V6.70802C8.28166 6.57422 7.94344 6.5 7.58789 6.5C6.20718 6.5 5.08789 7.61929 5.08789 9C5.08789 9.35555 5.16211 9.69377 5.29591 10H4.08789V7.25ZM10.0879 9C10.0879 8.44772 10.5356 8 11.0879 8C11.6402 8 12.0879 8.44772 12.0879 9C12.0879 9.55228 11.6402 10 11.0879 10H10.0879V9ZM8.58789 10H7.58789C7.03561 10 6.58789 9.55228 6.58789 9C6.58789 8.44772 7.03561 8 7.58789 8C8.13999 8 8.58759 8.44797 8.58789 9C8.58789 8.99982 8.58789 9.00018 8.58789 9V10ZM8.58789 12.5607V17.5H5.83789C4.87139 17.5 4.08789 16.7165 4.08789 15.75V11.5H7.52723L5.80756 13.2197C5.51467 13.5126 5.51467 13.9874 5.80756 14.2803C6.10045 14.5732 6.57533 14.5732 6.86822 14.2803L8.58789 12.5607ZM10.0879 17.5V12.5607L11.8076 14.2803C12.1005 14.5732 12.5753 14.5732 12.8682 14.2803C13.1611 13.9874 13.1611 13.5126 12.8682 13.2197L11.1486 11.5H21.0879V15.75C21.0879 16.7165 20.3044 17.5 19.3379 17.5H10.0879ZM10.0879 6.70802V5.5H19.3379C20.3044 5.5 21.0879 6.2835 21.0879 7.25V10H13.3799C13.5137 9.69377 13.5879 9.35555 13.5879 9C13.5879 7.61929 12.4686 6.5 11.0879 6.5C10.7323 6.5 10.3941 6.57422 10.0879 6.70802Z" />
      </svg>
    </span>
  );
};

export { RegularGiveaway };
